import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '@shared/state/AuthContext'

/**
 * Route guard for the administrator tools.
 *
 * It sits inside RequireAuth, so by the time it runs somebody is signed in and
 * the only question left is what they are allowed to open. Anyone else is sent
 * to the overview rather than shown a refusal: they were never offered the
 * tile, so arriving here at all means a typed URL or a stale bookmark, and a
 * page explaining what they cannot do is no use to them.
 *
 * As ever, this decides what is drawn. What actually holds is the row level
 * security policy on `tags`, which checks the email inside the signed token —
 * see docs/tag-admin.sql.
 */
export function RequireAdmin() {
  const { user, loading, roleKnown } = useAuth()

  // Wait for the server's answer (/api/me): a new administrator is not on
  // the list built into the page.
  if (loading || !roleKnown) return <div className="auth-gate" />
  if (user?.role !== 'admin') return <Navigate to="/" replace />

  return <Outlet />
}
